module.exports = __webpack_public_path__ + "img/logo.8450aa46.png";